
/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/24
 * @updateTime 2021/8/24
 * @decription 申请保全 =》 财产线索
 */
// 模块预览组件
import ccPreviewModule from '@/components/common/preview-module/index.vue';
import {
    TDDW,
    typeBz, typeCar, typeCclx,
} from "@/filters";

export default {
    name: 'Respondent',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        ccPreviewModule
    },
    // 参数
    props: {
        // 依赖数据,依赖被申请人列表数据
        dependData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    // 数据
    data() {
        return {
            // 数据列表
            data: [],
            // 财产总价值
            cczjz: 0,
            // 转换后的数据
            transformData: []
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 获取基本数据
        this.getData();
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {
        /**
         * 请求数据
         * @param {Object} params 请求参数
         * */
        requestData(params) {
            return this.$axios.get('ssbq/api/sqbq/ccxss', params);
        },

        /**
         * 获取行数据
         * @param {String} name 名称
         * @param {String|Number} value 值
         * @returns {Object}
         * */
        getRowData(name, value) {
            return {
                name: name,
                value: value
            };
        },

        /**
         * 获取转化之后的数据
         * @returns {Array} 转化之后的信息项数组
         * */
        getTransformData(data) {
            const _transformItemData = [];
            _transformItemData.push(this.getRowData('财产类型', data.cCclxName));
            _transformItemData.push(this.getRowData('财产所有人', data.cSqbqccyyzName));
            _transformItemData.push(this.getRowData('财产信息', data.cCcxxName));
            _transformItemData.push(this.getRowData('财产价值(元)', data.cSqbqccje));
            return _transformItemData;
        },

        /**
         * 获取财产信息数据
         * */
        ccxsValue(value) {
            switch (value.cCclx) {
                case '1':
                    return `${typeBz(value.cCclxzbz)}：${Number(value.cXjzje) ? Number(value.cXjzje).toFixed(2) : '--'}`
                case '2':
                    return `${value.cKhhmc} 账号：${value.cYhckzkhzh} ${Number(value.cYhckzckje) ? Number(value.cYhckzckje).toFixed(2) : '--'}${typeBz(value.cCclxzbz)}`
                case '3':
                    return `${value.cCclxzclpp} ${typeCar(value.cCclxcllx)} 车牌号：${value.cCklxzcldcph}`
                case '4':
                    return `${value.cCclxfcdz} ${value.cCclxfczh ? '房产证号：' + value.cCclxfczh : ''}`
                case '5':
                    return `${value.cCclxtdddz} 面积：${value.cCclxtdmj} ${TDDW(value.cYhckzckdw)} ${value.cCclxtddcqzh ? '产权证号：' + value.cCclxtddcqzh : ''}`
                case '6':
                    return `${value.cCclxzgpdgpmc} ${value.cCclxzgpdcgsl? value.cCclxzgpdcgsl+'股':''} `
                case '7':
                    return `${value.cCclxzjjdjjmc} ${value.cCclxzjjdjjsl ? value.cCclxzjjdjjsl + '份' : ''}`
                case '8':
                    return `${value.cCclxzzwdzqmc} ${value.cCclxzzwdzqmz} 元`
                case '9':
                    return `${value.cCclxzgqdcggs} ${value.cCclxzgqdczbl}%`
                case '11':
                    return `${value.cSbmc||'--'}`
                // case '10':
                //     return `${value.cCclxzswdtszh} ${Number(value.cSqbqccje) ? Number(value.cSqbqccje).toFixed(2) : '--'}`
                // case '255':
                //     return value.cMs
                default:
                    return value.cMs
            }
        },
        // 财产所有人姓名
        cSqbqccyyzmc(dataList, value) {
            let name = ''
            dataList.map((bqbsqrItem) => {
                if (bqbsqrItem.cBqDsrid === value) {
                    name = bqbsqrItem.cDsrlx == 1 ? bqbsqrItem.cDsrxm : bqbsqrItem.cQymc
                }
            })
            return name
        },

        /**
         * 获取数据
         * */
        getData() {
            // 请求申请人数据
            this.requestData({
                // 保全id
                bqid: sessionStorage.getItem('bqid')
            }).then(res => {
                const _data = res.data;
                const _transformData = [];
                let num = 0;
                _data.forEach((item) => {
                    // 财产类型
                    item.cCclxName = typeCclx(item.cCclx);
                    // 财产所有人
                    item.cSqbqccyyzName = this.cSqbqccyyzmc(this.dependData, item.cSqbqccyyz);
                    // 财产信息
                    item.cCcxxName = this.ccxsValue(item);
                    num += Number(item.cSqbqccje) * 100;
                    // 转化之后的数据
                    _transformData.push(this.getTransformData(item));
                });
                // 财产总价值
                this.cczjz = (num/100).toFixed(2);
                // 数据赋值
                this.data = _data;
                // 转化之后的数据
                this.transformData = _transformData;
                // 加载完成
                this.$emit('loaded', this.data);
            });
        }
    }
};
